
/* injects from baggage-loader */

'use strict'

import StageBaseController from '../stage-base.controller';

import { FormTypes, FormSizes, FormColors } from '../../index.const';

import { concat, shuffle } from 'lodash';

import { balloonsFirst, balloonsDone } from './stage-three.const';

export default class StageThreeController extends StageBaseController{
    constructor($log, $state, $Forms, Dialog, Session, Trophies) {
        'ngInject';
        super($log, $state, $Forms, Dialog, Session, Trophies);
        
        this.title = 'Arraste as figuras corretas para o álbum';
        this.name = 'Stage 3';
        this.type = 'size';
        this.forms1 = [];
        this.forms2 = [];
        this.forms3 = [];
        this.totalCompleted = 0;
        this.throphies = this.Trophies.getThrophies();
    }

    $onInit(){
        this.stages = this.Session.get().stages;
        this.genForms1();
        this.genForms2();
        this.genForms3();
        super.$onInit();
    }

    genForms1(){
        // Circle
        this.forms1 = concat(this.forms1, this.$Forms.create(FormTypes.circle, FormSizes.normal, FormColors.red, 2));
        this.forms1 = concat(this.forms1, this.$Forms.create(FormTypes.circle, FormSizes.small, FormColors.yellow, 5));
        this.forms1 = concat(this.forms1, this.$Forms.create(FormTypes.circle, FormSizes.big, FormColors.blue, 2));
        // Rect
        this.forms1 = concat(this.forms1, this.$Forms.create(FormTypes.rect, FormSizes.small, FormColors.red, 5));
        this.forms1 = concat(this.forms1, this.$Forms.create(FormTypes.rect, FormSizes.big, FormColors.yellow, 2));
        this.forms1 = concat(this.forms1, this.$Forms.create(FormTypes.rect, FormSizes.normal, FormColors.blue, 2));
        // Triangle
        this.forms1 = concat(this.forms1, this.$Forms.create(FormTypes.triangle, FormSizes.big, FormColors.red, 2));
        this.forms1 = concat(this.forms1, this.$Forms.create(FormTypes.triangle, FormSizes.small, FormColors.yellow, 5));
        this.forms1 = concat(this.forms1, this.$Forms.create(FormTypes.triangle, FormSizes.normal, FormColors.blue, 2));

        this.forms1 = shuffle(this.forms1);
    }
    genForms2(){
        // Circle
        this.forms2 = concat(this.forms2, this.$Forms.create(FormTypes.circle, FormSizes.normal, FormColors.red, 5));
        this.forms2 = concat(this.forms2, this.$Forms.create(FormTypes.circle, FormSizes.small, FormColors.yellow, 2));
        this.forms2 = concat(this.forms2, this.$Forms.create(FormTypes.circle, FormSizes.big, FormColors.blue, 2));
        // Rect
        this.forms2 = concat(this.forms2, this.$Forms.create(FormTypes.rect, FormSizes.small, FormColors.red, 2));
        this.forms2 = concat(this.forms2, this.$Forms.create(FormTypes.rect, FormSizes.big, FormColors.yellow, 2));
        this.forms2 = concat(this.forms2, this.$Forms.create(FormTypes.rect, FormSizes.normal, FormColors.blue, 5));
        // Triangle
        this.forms2 = concat(this.forms2, this.$Forms.create(FormTypes.triangle, FormSizes.big, FormColors.red, 2));
        this.forms2 = concat(this.forms2, this.$Forms.create(FormTypes.triangle, FormSizes.small, FormColors.yellow, 2));
        this.forms2 = concat(this.forms2, this.$Forms.create(FormTypes.triangle, FormSizes.normal, FormColors.blue, 5));

        this.forms2 = shuffle(this.forms2);
    }
    genForms3(){
        // Circle
        this.forms3 = concat(this.forms3, this.$Forms.create(FormTypes.circle, FormSizes.normal, FormColors.red, 2));
        this.forms3 = concat(this.forms3, this.$Forms.create(FormTypes.circle, FormSizes.small, FormColors.yellow, 2));
        this.forms3 = concat(this.forms3, this.$Forms.create(FormTypes.circle, FormSizes.big, FormColors.blue, 5));
        // Rect
        this.forms3 = concat(this.forms3, this.$Forms.create(FormTypes.rect, FormSizes.small, FormColors.red, 2));
        this.forms3 = concat(this.forms3, this.$Forms.create(FormTypes.rect, FormSizes.big, FormColors.yellow, 5));
        this.forms3 = concat(this.forms3, this.$Forms.create(FormTypes.rect, FormSizes.normal, FormColors.blue, 2));
        // Triangle
        this.forms3 = concat(this.forms3, this.$Forms.create(FormTypes.triangle, FormSizes.big, FormColors.red, 5));
        this.forms3 = concat(this.forms3, this.$Forms.create(FormTypes.triangle, FormSizes.small, FormColors.yellow, 2));
        this.forms3 = concat(this.forms3, this.$Forms.create(FormTypes.triangle, FormSizes.normal, FormColors.blue, 2));

        this.forms3 = shuffle(this.forms3);
    }

    isDropValid1(size){
        return FormSizes.small === size;
    }

    isDropValid2(size){
        return FormSizes.normal === size;
    }

    isDropValid3(size){
        return FormSizes.big === size;
    }

    onSuccess(){
        let totalCollected = 1;

        if(this.totalCompleted < 3){
            this.totalCompleted++;
            this.Session.updateStage(this.name, { totalCompleted: this.totalCompleted });

            if(this.totalCompleted >= 3){
                if(this.stages[0].completed || this.stages[1].completed || this.stages[2].completed){
                    this.Dialog.showInterventionalModal("Winner",balloonsDone);
                    this.Session.updateStage(this.name, { completed: true });
                    this.$state.go('main.stage-seventh');
                }else{
                    this.Dialog.showInterventionalTrophiesModal(totalCollected, () => {
                        this.Dialog.showInterventionalModal("Winner",balloonsFirst);
                        this.Session.updateStage(this.name, { completed: true });
                        this.$state.go('main.stage-seventh');

                    });
                    
                }
            }
        }
    }

    onFail(){
        // this.Dialog.showAlert('Opa!', 'Nostrud anim officia consequat irure aliqua amet Lorem officia.');
    }
}


// WEBPACK FOOTER //
// ./src/app/pages/stage-three/stage-three.controller.js